module.exports = require("/Users/martin/dev/playground/jam-maniacs/app/.gatsby/gatsby-browser.tsx");